module.exports = __webpack_public_path__ + "media/images/version_merge/mastercard_logo-b74ad20b2e08829e2ce392d4a9ae635e.png";